<mat-radio-group [formControl]="scheduleMode" class="schedule-mode">
  <mat-radio-button value="OneTime">One-time</mat-radio-button>
  <mat-radio-button value="Recurring">Recurring</mat-radio-button>
</mat-radio-group>

@if (isRecurring()) {
  <form [formGroup]="recurrenceForm" class="recurrence-form">
    <mat-form-field appearance="outline">
      <mat-label>First local run</mat-label>
      <input matInput formControlName="firstLocalStartDateTime" type="datetime-local" aria-label="First local run" required/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Recurrence kind</mat-label>
      <mat-select formControlName="recurrenceKind" required>
        <mat-option value="Daily">Daily</mat-option>
        <mat-option value="Weekly">Weekly</mat-option>
        <mat-option value="Monthly">Monthly</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Interval</mat-label>
      <input matInput formControlName="interval" type="number" min="1" aria-label="Interval" required/>
    </mat-form-field>
    @if (recurrenceForm.value.recurrenceKind === 'Weekly') {
      <div class="weekday-options">
        <span class="weekday-label">Weekdays</span>
        @for (day of weekdays; track day) {
          <mat-checkbox
            [checked]="recurrenceForm.value.weekdays.indexOf(day) >= 0"
            (change)="toggleWeekday(day, $event.checked)">
            {{ day }}
          </mat-checkbox>
        }
      </div>
    }
    @if (recurrenceForm.value.recurrenceKind === 'Monthly') {
      <mat-form-field appearance="outline">
        <mat-label>Day of month</mat-label>
        <input matInput formControlName="dayOfMonth" type="number" min="1" max="31" aria-label="Day of month" required/>
      </mat-form-field>
    }
    <mat-form-field appearance="outline">
      <mat-label>End local date/time</mat-label>
      <input matInput formControlName="endLocalDateTime" type="datetime-local" aria-label="End local date/time"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Maximum occurrences</mat-label>
      <input matInput formControlName="maxOccurrenceCount" type="number" min="1" aria-label="Maximum occurrences"/>
    </mat-form-field>
  </form>
}
